import { autoAnimatePlugin } from '@formkit/auto-animate/vue';
import { createApp } from 'vue';

import { microAnimateDirective } from '@/services/micro-animations.js';

// Vue 2 replaces the tag where app is mounted, vue 3 doesn't
// Used for VirtualMarketplaceEnquiry.vue
function mountAndReplaceTag(app, selector) {
  const fragment = document.createDocumentFragment();
  const target = document.querySelector(selector);

  app.mount(fragment);
  target.parentNode.replaceChild(fragment, target);
  return app;
}

export const mountApp = (App, selector, plugins = [], beforeMountCallback = null, rootProps = {}) => {
  let app = createApp(App, rootProps);

  app.directive('auto-animate', microAnimateDirective);

  // v-auto-animate is registered above with our shared keyframes — a caller-provided autoAnimatePlugin would overwrite it
  plugins.filter(plugin => plugin !== autoAnimatePlugin).forEach(plugin => {
    app.use(plugin);
  });

  if (beforeMountCallback) {
    beforeMountCallback(app);
  }

  app = mountAndReplaceTag(app, selector);

  if (process.env.NODE_ENV === 'production') {
    app.config.errorHandler = (err, vm, info) => {
      console.error(err, vm, info);

      window.Rollbar.error(err, {
        info,
      });
    };
  }

  app.config.devtools = process.env.NODE_ENV !== 'production' || App.debug;
  app.config.performance = process.env.NODE_ENV !== 'production';

  return app;
};
